import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function getMentorAPI(authToken: string, mentorId: string): Observable<any> {
    return educatAPI.get(
        `mentors/${mentorId}`,
        new RestQueryParams(),
        {
            Authorization: `Bearer ${authToken}`
        }
    );
}
